import type { SideComponentProps } from '@/common/types/app';
import { PageTitle } from '@/components/PageTitle/PageTitle';
import { NewReferral } from '@/views/Referrals';

const NewReferralPage: SideComponentProps = () => {
  return (
    <>
      <PageTitle title="Create Client Referral | Side" />
      <NewReferral />
    </>
  );
};

NewReferralPage.appShellProps = {
  hideInteractionSidebar: true,
};

NewReferralPage.disableInteractionValidation = true;

export default NewReferralPage;
